export const fetchStates = () => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/plate2vin/states?a=b&api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
      QuestionConversion: 'fury',
      Date: new Date().toUTCString(),
    },
    method: 'GET',
    mode: 'cors',
    redirect: 'follow',
  })
    .then((res) => res.json())
    .then((res) => {
      return res.data.states;
    });
};

export default { fetchStates };
